<mat-card class="mat-elevation-z0">
    <mat-card-title><strong>Are you sure?</strong></mat-card-title>
    <mat-card-actions>
        <button mat-raised-button type="button" (click)="cancel()">Cancel</button>
        <button mat-raised-button type="button" color="primary" (click)="submit()">Ok</button>
    </mat-card-actions>
</mat-card>